import React from 'react';
import VaultActiveFilterChips from '../VaultActiveFilterChips/VaultActiveFilterChips';

export const getVaultHeroBrowseExtras = ({
    formData,
    onFiltersApply,
    onClearFilters,
}) => {
    const data = formData || {};
    const chips = [
        data.driverName && { key: 'driverName', label: data.driverName },
        data.series && { key: 'series', label: data.series },
        data.year && { key: 'year', label: data.year },
    ].filter(Boolean);

    const handleRemoveChip = (key) => {
        onFiltersApply?.({ ...data, [key]: '' });
    };

    return {
        belowToolbar: chips.length > 0 ? (
            <VaultActiveFilterChips
                chips={chips}
                onRemove={handleRemoveChip}
                onClearAll={onClearFilters}
            />
        ) : null,
    };
};
